import { Icon } from "@chakra-ui/react"

const ProxyRuleManagementIcon = () => {
  return (
    <Icon width='24px' height='24px' viewBox='0 0 24 24'>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        {/* center node */}
        <path
          d='M12 9 A3 3 0 1 0 12 15 A3 3 0 1 0 12 9'
          stroke='#999A9A'
          strokeWidth='1.5'
          fill='none'
        />

        {/* left node */}
        <path
          d='M4 10 A2 2 0 1 0 4 14 A2 2 0 1 0 4 10'
          stroke='#999A9A'
          strokeWidth='1.5'
          fill='none'
        />

        {/* right node */}
        <path
          d='M20 10 A2 2 0 1 0 20 14 A2 2 0 1 0 20 10'
          stroke='#999A9A'
          strokeWidth='1.5'
          fill='none'
        />

        {/* top node */}
        <path
          d='M12 2 A2 2 0 1 0 12 6 A2 2 0 1 0 12 2'
          stroke='#999A9A'
          strokeWidth='1.5'
          fill='none'
        />

        {/* bottom node */}
        <path
          d='M12 18 A2 2 0 1 0 12 22 A2 2 0 1 0 12 18'
          stroke='#999A9A'
          strokeWidth='1.5'
          fill='none'
        />

        {/* connections */}
        <path
          d='M6 12H9M15 12H18M12 6V9M12 15V18'
          stroke='#999A9A'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </svg>
    </Icon>
  )
}

export default ProxyRuleManagementIcon
